import { SET_LOAN_IS_VISIBLE } from './constants';

export const setLoanIsVisible = isVisible => ({
    type: SET_LOAN_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/Loan/actions.js